import React, { useState, useEffect } from 'react'
import { useQueryParams } from 'raviger'

import { colors } from 'Constants'
import { getReport } from '../helpers'
import request from 'Request'

import { Flex } from 'lese'
import ScaleLoader from 'react-spinners/ScaleLoader'
import ReportTitle from '../components/ReportTitle'
import ReportHeader from '../components/ReportHeader'
import DeviceReport from './components/DeviceReport'

import { useStore } from 'laco-react'
import { ReportSortingStore } from 'Store'

export default () => {
  const reportSortingState = useStore(ReportSortingStore)
  const [
    { startDate, endDate, showArchivedOffices },
    setQuery
  ] = useQueryParams()
  const [reportSets, setReportSets] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(async () => {
    const newReportSet = await request('/info/app-codes/list').then(res =>
      res.data.map(appCode => ({ appCode, reports: [] }))
    )
    const requests = []
    for (const reportSet of newReportSet) {
      requests.push(
        getReport('/reports/device/get', {
          appCode: reportSet.appCode,
          startDate,
          endDate,
          showArchivedOffices
        }).then(reports => (reportSet.reports = reports))
      )
    }
    await Promise.all(requests)
    // TODO: Add sorting by response count
    setReportSets(newReportSet)
    setLoading(false)
  }, [])

  return (
    <>
      <ReportTitle
        title={`Cluster Device Report`}
        csvUrl="/reports/device/csv"
        csvPayload={reportSortingState}
      />
      {loading && (
        <Flex xAlign yAlign height="70vh">
          <ScaleLoader color={colors.secondary} loading={loading} />
        </Flex>
      )}
      {reportSets.map(reportSet => (
        <>
          <ReportHeader
            header="App Code"
            title={reportSet.appCode}
            cardValues={[]}
          ></ReportHeader>
          {reportSet.reports.map(report => (
            <>
              <ReportHeader
                header="Office"
                title={report.title}
                cardValues={[
                  ['Total', 'Responses', report.totalBreakdown.totalResponses],
                  [
                    'Total',
                    'BT Cuff Responses',
                    report.totalBreakdown.totalResponsesWithBpCuff
                  ],
                  [
                    'Total',
                    'Non-BT Cuff Responses',
                    report.totalBreakdown.totalResponsesWithNoBpCuff
                  ],
                  ['Total', 'Journeys', report.totalBreakdown.totalJourneys]
                ]}
              />
              <ReportHeader
                header=" "
                title=" "
                cardValues={[
                  ['Total', 'Patients', report.totalBreakdown.totalPatients],
                  [
                    'Total',
                    'BT Cuff Patients',
                    report.totalBreakdown.totalPatientsWithBpCuff
                  ],
                  [
                    'Total',
                    'Non-BT Cuff Patients',
                    report.totalBreakdown.totalPatientsWithNoBpCuff
                  ]
                ]}
              />
              <DeviceReport report={report} />
              <hr
                style={{
                  width: '100%',
                  border: `1px solid ${colors.borderColor}`
                }}
              />
            </>
          ))}
        </>
      ))}
    </>
  )
}
